export default __webpack_public_path__ + "static/media/armour.bf135d5b.png";